// 「あなたがよく注文するメニュー」を非表示にする merchant ID 一覧。
// かにざんまい (kOwyHaXtTOg8osmAnvYp): 複数コースに同じ商品が紐付いており、
// 過去の高コース限定商品が低コース訪問時に「よく注文するメニュー」へ混入するため非表示。
// (該当 merchant 配下の全店舗が対象)
export const HIDE_ITEMS_YOU_OFTEN_ORDER_MERCHANT_IDS = [
  'kOwyHaXtTOg8osmAnvYp',
];

export const shouldHideItemsYouOftenOrder = (
  merchantId: string | undefined
): boolean =>
  HIDE_ITEMS_YOU_OFTEN_ORDER_MERCHANT_IDS.includes(merchantId ?? '');
